<template>
    <v-container class="pa-2">
        <v-row dense>
            <v-col cols="12" sm="8" offset-sm="2" md="6" offset-md="3">

                <!-- Header sticky -->
                <v-card class="rounded-xl elevation-2 px-3 py-2 mb-3 sticky-header">
                    <div class="d-flex align-center">
                        <v-icon color="primary" class="mr-2">mdi-plus-circle-outline</v-icon>
                        <div class="text-subtitle-2 font-weight-bold primary--text flex-grow-1">Nuova Circoscrizione</div>
                        <v-chip x-small color="grey darken-1" dark>SUPER-ADMIN</v-chip>
                    </div>
                </v-card>

                <!-- Form -->
                <v-card v-if="!risultato" class="rounded-xl elevation-2 mb-3">
                    <div class="section-header">
                        <v-icon x-small color="grey darken-1" class="mr-1">mdi-form-textbox</v-icon>
                        <span>Dati circoscrizione</span>
                    </div>
                    <v-card-text class="pt-2 pb-3 px-3">
                        <v-form v-model="formValid" ref="form">
                            <v-text-field
                                v-model="form.nomeCircoscrizione"
                                outlined rounded dense
                                label="Nome Circoscrizione"
                                prepend-inner-icon="mdi-domain"
                                :rules="[v => !!v || 'Campo obbligatorio']"
                                class="mb-2" />
                            <v-text-field
                                v-model="form.codiceCircoscrizione"
                                outlined rounded dense
                                label="Codice Circoscrizione"
                                prepend-inner-icon="mdi-identifier"
                                :rules="[v => !!v || 'Campo obbligatorio']"
                                class="mb-2" />
                            <v-divider class="mb-3" />
                            <div class="text-caption grey--text mb-2 px-1">Amministratore App</div>
                            <v-text-field
                                v-model="form.nomeAdmin"
                                outlined rounded dense
                                label="Nome"
                                prepend-inner-icon="mdi-account-outline"
                                :rules="[v => !!v || 'Campo obbligatorio']"
                                class="mb-2" />
                            <v-text-field
                                v-model="form.cognomeAdmin"
                                outlined rounded dense
                                label="Cognome"
                                prepend-inner-icon="mdi-account-outline"
                                :rules="[v => !!v || 'Campo obbligatorio']"
                                class="mb-2" />
                            <v-text-field
                                v-model="form.congregazione"
                                outlined rounded dense
                                label="Congregazione"
                                prepend-inner-icon="mdi-home-city-outline"
                                :rules="[v => !!v || 'Campo obbligatorio']"
                                class="mb-2" />
                            <v-divider class="mb-3" />
                            <div class="text-caption grey--text mb-2 px-1">OneSignal</div>
                            <v-select
                                v-model="form.onesignalShard"
                                outlined rounded dense
                                label="Shard notifiche"
                                prepend-inner-icon="mdi-bell-ring-outline"
                                :items="shardOptions"
                                :rules="[v => !!v || 'Campo obbligatorio']"
                                class="mb-1" />
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="px-3 pb-3">
                        <v-spacer />
                        <v-btn rounded depressed color="deep-purple darken-1" dark
                            :loading="loading"
                            :disabled="!formValid"
                            @click="creaCircoscrizione">
                            <v-icon small left>mdi-check</v-icon>
                            Crea circoscrizione
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <!-- Import da Excel -->
                <v-card v-if="!risultatoImport" class="rounded-xl elevation-2 mb-3">
                    <div class="section-header">
                        <v-icon x-small color="grey darken-1" class="mr-1">mdi-file-excel-outline</v-icon>
                        <span>Importa da Excel</span>
                    </div>
                    <v-card-text class="pt-2 pb-3 px-3">
                        <v-text-field
                            v-model="importForm.codice"
                            outlined rounded dense
                            label="Codice Circoscrizione"
                            prepend-inner-icon="mdi-identifier"
                            class="mb-2" />
                        <v-text-field
                            v-model="importForm.nome"
                            outlined rounded dense
                            label="Nome Circoscrizione"
                            prepend-inner-icon="mdi-domain"
                            class="mb-2" />
                        <v-select
                            v-model="importForm.onesignalShard"
                            outlined rounded dense
                            label="Shard notifiche"
                            prepend-inner-icon="mdi-bell-ring-outline"
                            :items="shardOptions"
                            class="mb-2" />
                        <v-file-input
                            v-model="importForm.file"
                            outlined rounded dense
                            label="File Excel ORATORI PUBBLICI ESTERNI"
                            accept=".xlsx,.xls"
                            prepend-icon=""
                            prepend-inner-icon="mdi-upload"
                            class="mb-1" />
                    </v-card-text>
                    <v-card-actions class="px-3 pb-3">
                        <v-spacer />
                        <v-btn rounded depressed color="green darken-2" dark
                            :loading="loadingImport"
                            :disabled="!importForm.codice || !importForm.nome || !importForm.file || !importForm.onesignalShard"
                            @click="importaCircoscrizione">
                            <v-icon small left>mdi-import</v-icon>
                            Importa
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <!-- Risultato Import -->
                <v-card v-if="risultatoImport" class="rounded-xl elevation-2 mb-3">
                    <div class="section-header">
                        <v-icon x-small color="success" class="mr-1">mdi-check-circle-outline</v-icon>
                        <span>Import completato</span>
                    </div>
                    <v-card-text class="pt-3 pb-3 px-3">
                        <div class="text-body-2 mb-3">
                            Circoscrizione <strong>{{ importForm.nome }}</strong> importata con successo.
                        </div>
                        <div class="text-caption grey--text">Congregazioni: <strong>{{ risultatoImport.congregazioniCreate }}</strong></div>
                        <div class="text-caption grey--text">Oratori: <strong>{{ risultatoImport.oratoriCreati }}</strong></div>
                        <div class="text-caption grey--text mb-3">Schemi assegnati: <strong>{{ risultatoImport.schemiAssegnati }}</strong></div>
                        <div v-if="risultatoImport.warning && risultatoImport.warning.length" class="mb-2">
                            <div class="text-caption font-weight-bold orange--text mb-1">Avvisi ({{ risultatoImport.warning.length }}):</div>
                            <div v-for="(w, i) in risultatoImport.warning" :key="i" class="text-caption grey--text">• {{ w }}</div>
                        </div>
                    </v-card-text>
                    <v-card-actions class="px-3 pb-3">
                        <v-btn text rounded color="grey darken-1" small @click="resetImport">
                            <v-icon small left>mdi-plus</v-icon>
                            Nuovo import
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <!-- Risultato -->
                <v-card v-if="risultato" class="rounded-xl elevation-2 mb-3">
                    <div class="section-header">
                        <v-icon x-small color="success" class="mr-1">mdi-check-circle-outline</v-icon>
                        <span>Circoscrizione creata</span>
                    </div>
                    <v-card-text class="pt-3 pb-3 px-3">
                        <div class="text-body-2 grey--text mb-4">
                            Circoscrizione <strong>{{ form.nomeCircoscrizione }}</strong> creata con successo.
                            Credenziali dell'amministratore app:
                        </div>

                        <!-- Username -->
                        <div class="cred-box d-flex align-center pa-3 rounded-lg mb-2" @click="copiaCredenziale(risultato.username, 'username')">
                            <div class="flex-grow-1">
                                <div class="text-caption grey--text">Username (Codice)</div>
                                <div class="text-body-1 font-weight-bold font-mono">{{ risultato.username }}</div>
                            </div>
                            <v-btn icon small color="primary" @click.stop="copiaCredenziale(risultato.username, 'username')">
                                <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                        </div>

                        <!-- Password -->
                        <div class="cred-box d-flex align-center pa-3 rounded-lg mb-4" @click="copiaCredenziale(risultato.password, 'password')">
                            <div class="flex-grow-1">
                                <div class="text-caption grey--text">Password</div>
                                <div class="text-body-1 font-weight-bold font-mono">{{ risultato.password }}</div>
                            </div>
                            <v-btn icon small color="primary" @click.stop="copiaCredenziale(risultato.password, 'password')">
                                <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                        </div>

                        <!-- Copia tutto -->
                        <v-btn block rounded depressed color="primary" @click="copiaTutto">
                            <v-icon small left>mdi-content-copy</v-icon>
                            Copia entrambe
                        </v-btn>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="px-3 py-3">
                        <v-btn text rounded color="grey darken-1" small @click="reset">
                            <v-icon small left>mdi-plus</v-icon>
                            Nuova circoscrizione
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

        <!-- Snackbars -->
        <v-snackbar v-model="snackCopy" timeout="1800" color="success" bottom>
            <v-icon dark class="mr-2" small>mdi-content-copy</v-icon>
            {{ snackMsg }}
        </v-snackbar>
        <v-snackbar v-model="snackError" timeout="2500" color="error" bottom>
            <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
            Errore durante la creazione.
        </v-snackbar>
        <v-snackbar v-model="snackConflict" timeout="3000" color="warning" bottom>
            <v-icon dark class="mr-2">mdi-alert-outline</v-icon>
            Codice circoscrizione già esistente.
        </v-snackbar>
    </v-container>
</template>

<script>
import Store from '@/store/store'

export default {
    name: 'NuovaCircoscrizione',
    data: () => ({
        formValid: false,
        loading: false,
        risultato: null,
        snackCopy: false,
        snackError: false,
        snackConflict: false,
        snackMsg: '',
        loadingImport: false,
        risultatoImport: null,
        importForm: {
            codice: '',
            nome: '',
            onesignalShard: '',
            file: null,
        },
        form: {
            nomeCircoscrizione: '',
            codiceCircoscrizione: '',
            nomeAdmin: '',
            cognomeAdmin: '',
            congregazione: '',
            onesignalShard: '',
        },
    }),
    computed: {
        shardOptions() {
            return this.$store.state.talkShards.map(s => ({
                text: s.name + '  (' + s.appId + ')',
                value: s.name,
            }));
        },
    },
    methods: {
        async creaCircoscrizione() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore?.codice,
                token: this.$store.state.oratore?.token,
                nomeCircoscrizione: this.form.nomeCircoscrizione,
                codiceCircoscrizione: this.form.codiceCircoscrizione,
                nomeAdmin: this.form.nomeAdmin,
                cognomeAdmin: this.form.cognomeAdmin,
                congregazione: this.form.congregazione,
                onesignalShard: this.form.onesignalShard,
            };
            try {
                const response = await fetch(
                    process.env.VUE_APP_SERVER + '/api/circoscrizione/creaCircoscrizione',
                    {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + Store.state.accessToken,
                        },
                        body: JSON.stringify(paramJson),
                    }
                );
                if (response.status === 409) {
                    this.snackConflict = true;
                } else if (response.ok) {
                    this.risultato = await response.json();
                } else {
                    this.snackError = true;
                }
            } catch (e) {
                this.snackError = true;
            }
            this.loading = false;
        },
        copiaCredenziale(valore, tipo) {
            const testo = valore?.toString() || '';
            if (navigator.clipboard) {
                navigator.clipboard.writeText(testo);
            } else {
                const el = document.createElement('textarea');
                el.value = testo;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
            this.snackMsg = tipo === 'username' ? 'Username copiato.' : 'Password copiata.';
            this.snackCopy = true;
        },
        copiaTutto() {
            const testo = `Username: ${this.risultato.username}\nPassword: ${this.risultato.password}`;
            if (navigator.clipboard) {
                navigator.clipboard.writeText(testo);
            } else {
                const el = document.createElement('textarea');
                el.value = testo;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
            this.snackMsg = 'Credenziali copiate.';
            this.snackCopy = true;
        },
        reset() {
            this.risultato = null;
            this.$nextTick(() => {
                this.$refs.form?.resetValidation();
            });
        },
        async importaCircoscrizione() {
            this.loadingImport = true;
            try {
                // Vuetify 2 v-file-input può restituire File o File[]
                const fileObj = Array.isArray(this.importForm.file)
                    ? this.importForm.file[0]
                    : this.importForm.file;
                if (!fileObj) { this.snackError = true; this.loadingImport = false; return; }

                const fd = new FormData();
                fd.append('file', fileObj, fileObj.name);

                const qs = new URLSearchParams({
                    partition:     this.$store.state.partition,
                    username:      this.$store.state.oratore?.codice?.toString() || '',
                    token:         this.$store.state.oratore?.token || '',
                    codice:        this.importForm.codice,
                    nome:          this.importForm.nome,
                    onesignalShard: this.importForm.onesignalShard,
                }).toString();

                const response = await fetch(
                    process.env.VUE_APP_SERVER + '/api/import/circoscrizione?' + qs,
                    {
                        method: 'POST',
                        headers: { 'Authorization': 'Bearer ' + Store.state.accessToken },
                        body: fd,
                    }
                );
                if (response.status === 409) {
                    this.snackConflict = true;
                } else if (response.ok) {
                    this.risultatoImport = await response.json();
                } else {
                    this.snackError = true;
                }
            } catch (e) {
                this.snackError = true;
            }
            this.loadingImport = false;
        },
        resetImport() {
            this.risultatoImport = null;
            this.importForm = { codice: '', nome: '', onesignalShard: '', file: null };
        },
    },
}
</script>

<style scoped>
.sticky-header {
    position: sticky;
    top: 0;
    z-index: 4;
}
.section-header {
    display: flex;
    align-items: center;
    padding: 10px 14px 6px;
    font-size: 0.72rem;
    font-weight: 700;
    color: rgba(0,0,0,0.5);
    letter-spacing: 0.03em;
    text-transform: uppercase;
}
.theme--dark .section-header {
    color: rgba(255,255,255,0.45);
}
.cred-box {
    background: rgba(0,0,0,0.04);
    cursor: pointer;
}
.theme--dark .cred-box {
    background: rgba(255,255,255,0.06);
}
.font-mono {
    font-family: 'Courier New', Courier, monospace;
    letter-spacing: 0.04em;
}
</style>
